import { parseMarkdown } from 'services/imports/markdownContract';
import type { MarkdownLine } from 'services/imports/markdownContract';
import { stripRowIds } from 'views/imports/doc-model';
import { humanKeyLabel } from 'views/imports/key-labels';

export const relatedFilterFor = (key: string): string => {
  const segments = key.split('.');
  return segments.length > 2 ? segments.slice(0, -1).join('.') : key;
};

export const matchesFilter = (line: Pick<MarkdownLine, 'key' | 'value'>, filter: string): boolean => {
  const words = filter.trim().toLowerCase().split(/\s+/).filter((word) => word !== '');
  if (words.length === 0) return true;
  const haystack = [line.key, humanKeyLabel(line.key), line.value].join(' ').toLowerCase();
  return words.every((word) => haystack.includes(word));
};

/** The data lines of the markdown that match, exactly as they are written (row ids hidden). */
export const filterMarkdownLines = (markdown: string, filter: string): string => parseMarkdown(markdown).lines
  .filter((line) => matchesFilter(line, filter))
  .map((line) => stripRowIds(line.raw))
  .join('\n');
